/* ============================================
   Sticky Sound Buttons — Sound + Navigation
   ============================================ */
(function () {
  'use strict';

  function init(container) {
    if (!container) return;

    var audio = container.querySelector('[data-ssb-audio]');
    var soundBtn = container.querySelector('[data-ssb-sound-btn]');

    if (soundBtn && audio && audio.src) {
      audio.addEventListener('ended', function () {
        soundBtn.classList.remove('is-playing');
      });

      soundBtn.addEventListener('click', function () {
        if (audio.paused) {
          if (audio.ended) {
            audio.currentTime = 0;
          }
          audio.play().catch(function () {});
          soundBtn.classList.add('is-playing');
        } else {
          audio.pause();
          soundBtn.classList.remove('is-playing');
        }
      });
    }

    /* Hide when hamburger menu or search is open */
    var header = document.querySelector('.section-header');
    if (header) {
      function checkHeaderOverlays() {
        var menuOpen = header.classList.contains('menu-open');
        var searchOpen = !!header.querySelector('details-modal details[open]');
        container.classList.toggle('is-hidden', menuOpen || searchOpen);
      }

      new MutationObserver(checkHeaderOverlays).observe(header, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
      });
    }
  }

  function boot() {
    var sections = document.querySelectorAll('[data-sticky-sound-buttons]');
    sections.forEach(function (section) {
      init(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var container = e.target.querySelector('[data-sticky-sound-buttons]');
    if (container) init(container);
  });
})();
